import React from "react";
import styles from "./styles.module.scss";

interface Props {
  message?: string;
}

export const InputError: React.FC<Props> = ({ message }) => {
  return (
    <div className={styles["input-error"]}>
      <p className={styles.error}>{message}</p>
    </div>
  );
};
